import { Injectable } from "@angular/core";

@Injectable({ providedIn: 'root' })

export class AesGcmCryptoService {

    private keyHex = 'fa7a1d1f78f7d8b6998f0ccf1f788d17ecb97a859690fb5fb10d49f13be929e8';
    private ivHex = 'c6ee45313a81e9ec2bf0eb1d0696a05e';
    
    async encrypt(plainText: string): Promise<string> {

        const key = this.hexToBytes(this.keyHex);
        const iv = this.hexToBytes(this.ivHex);
    
        const cryptoKey = await window.crypto.subtle.importKey(
          'raw', key, 'AES-GCM', false, ['encrypt']
        );
    
        const encoder = new TextEncoder();
        const encodedText = encoder.encode(plainText);
    
        const cipherText = await window.crypto.subtle.encrypt(
          {
            name: 'AES-GCM',
            iv: iv
          },
          cryptoKey,
          encodedText
        );
    
        const combined = new Uint8Array(cipherText.byteLength);
        combined.set(new Uint8Array(cipherText));
    
        return this.bytesToBase64(combined);
      }
    
      async decrypt(encryptedText: string): Promise<string> {
        const key = this.hexToBytes(this.keyHex);
        const iv = this.hexToBytes(this.ivHex);
    
        const cryptoKey = await window.crypto.subtle.importKey(
          'raw',
          key,
          'AES-GCM',
          false,
          ['decrypt']
        );
    
        const combined = this.base64ToBytes(encryptedText);
        const cipherText = combined.subarray(0, combined.length);
    
        const plainTextBuffer = await window.crypto.subtle.decrypt(
          {
            name: 'AES-GCM',
            iv: iv
          },
          cryptoKey,
          cipherText
        );
    
        const decoder = new TextDecoder();
        return decoder.decode(plainTextBuffer);
      }
    
      private hexToBytes(hex: string): Uint8Array {
        const bytes = new Uint8Array(hex.length / 2);
        for (let i = 0; i < bytes.length; i++) {
          bytes[i] = parseInt(hex.substr(i * 2, 2), 16);
        }
        return bytes;
      }
    
      private bytesToBase64(bytes: Uint8Array): string {
        let binary = '';
        const len = bytes.byteLength;
        for (let i = 0; i < len; i++) {
          binary += String.fromCharCode(bytes[i]);
        }
        return window.btoa(binary);
      }

      private base64ToBytes(base64: string): Uint8Array {
        const binary = window.atob(base64);
        const len = binary.length;
        const bytes = new Uint8Array(len);
        for (let i = 0; i < len; i++) {
          bytes[i] = binary.charCodeAt(i);
        }
        return bytes;
      }
}